import Radio from 'backbone.radio';
import session from '@/models/v5/session';
import WebsocketsManager from '@/models/websockets_manager';


    var globalCh = Radio.channel('global');
    var apiCh = Radio.channel('api');

    export default function(options) {
        options = options || {};
        var ws;

        // Ping the server every N milliseconds.
        // We do this because under some circumstances, a websocket connection
        // will be closed by gateways (like Amazon ELB) that think the line has gone dead.
        // (We should get a 'pong' back, but we don't care enough to check.)
        var PING_INTERVAL_MS = 20000; // 20 seconds
        var ping_timer = null;

        function ping() {
            ws.send(JSON.stringify({ command: 'ping' }));
            ping_timer = setTimeout(ping, PING_INTERVAL_MS);
        }

        /**
         * Extend the log message with a target_account. Necessary for multiuser.
         * We do this here because there are multiple instances where we send the
         * log command and we only want to do this once.
         * @param String msg, a json string
         */
        function send(original_msg) {
            var obj = JSON.parse(original_msg);
            var msg = original_msg;
            var active = globalCh.request('active_account');

            // Only trapping 'log' websockets commands for now
            // If target_account has already been set, don't overwrite.
            if (obj.command == 'log' && !obj.target_account) {
                obj.target_account = active.id;
                msg = JSON.stringify(obj);
            }
            WebsocketsManager.prototype.send.call(this, msg);
        }

        ws = new WebsocketsManager({
            verbose: options.verbose || false,
            url: options.web_sockets && options.web_sockets.origin || ''
        });
        ws.send = send;

        ws.on('open', function() {
            clearTimeout(ping_timer);
            ping_timer = setTimeout(ping, PING_INTERVAL_MS);

            // Send bearer token immediately
            ws.send(JSON.stringify({ token: session.get('access_token') }));
        });

        ws.on('close', function() {
            clearTimeout(ping_timer);
        });

        ws.on('command:new_device', function(obj) {
            // FIXME / TODO
            // This was originally a workaround for the backend telling us about factory devices
            // over the WebSocket, but that bug has since been fixed.
            //
            // This workaround is now necessary with multi-user because we only get a device ID in
            // the WebSocket message, which means we don't know what account the device belongs to.
            //
            // So when we receive a new_device message, just fetch the Devices collections for both
            // the primary and active accounts.
            var active_account = globalCh.request('active_account');
            var primary_account = globalCh.request('primary_account');
            var devices = apiCh.request('device');
            
            var remote_device_id = obj && obj.data && obj.data.device_id; 
            var new_device;
            if (remote_device_id) {
                new_device = devices.add({ id: remote_device_id });
                new_device.fetch();
                
            }
            if (active_account.devices &&
                 active_account.permits(primary_account, "view_development_devices")) {
                    active_account.devices.fetch();
            }
            if (primary_account.devices) { primary_account.devices.fetch(); }

            // Normally, we'd do this (though it needs to be updated for multi-user):
            // Devices.add({
            //   id      : json.data.device_id,
            //   name    : (json.data.name || json.data.device_id)
            // });
        });

        ws.on('command:agent_status', function(json) {
            var devices = apiCh.request('device');
            if (!devices) return;

            var device = devices.get(json.data.device_id);
            if (device) {
                if (json.data.status === 'online') {
                    device.set('agent_running', true);
                } else {
                    device.set('agent_running', false);
                }
                device.set('agent_status', json.data.status);
            }
        });

        ws.on('command:device_status', function(json) {
            var devices = apiCh.request('device');
            if (!devices) return;

            var device = devices.get(json.data.device_id);
            if (device) {
                device.set({
                    'powerstate': json.data.status,
                    'device_online': json.data.status === 'online'
                });
            }
        });

        ws.on('command:billing_change', function() {
            let primary = globalCh.request('primary_account');
            primary.trigger('billing_change');
        });

        ws.on('command:editing', function(json) {
            globalCh.request('wsEditing', json.data);
        });

        ws.on('command:create', function(json) {
            if (json.payload.data && json.payload.data.type === 'revision') {
                globalCh.request('wsCreateRevision', json.payload);
            }
            if (json.payload.data && json.payload.data.type === 'notification') {
                globalCh.request('wsCreateNotification', json.payload);
            }
        });
        ws.on('command:dut', function(json) {
            // When duts come in we want to find the devicegroup they belong to 
            // and put the device in the group's dut collection. We do this
            // directly rather than place it in the global collection because
            // DUTs are not currently managed under the global collection.
            var data = json.payload && json.payload.data;
            if (!data) 
                return console.warn("Got a dut event with unusable data %o", json);
            
            // If we do have usable data, we now need to make this event look like 
            // a bonafide v5 event and set the type. Type is going to need to be 'dut'
            // so that this device goes into the global duts collection and not the
            // global devices collection.
            data.type = 'dut';
            json.command = 'create';
            return consume_v5events(json);
        });
        ws.on('command:remove_dut', function(json) {
            var data = json.payload && json.payload.data;
            if (!data) 
                return console.warn("Got a dut event with unusable data %o", json);
            // See notes above. We need to make this event look like a v5_event
            data.type = 'dut';
            json.command = 'delete';
            return consume_v5events(json);
        });
        var v5_events = 'command:create command:update command:delete';
        var COMMANDS = ['create', 'read', 'update', 'delete'];
        /**
         * v5 events have the signature
         * {
         *   command: <crud-verb>,
         *   payload: <payload>
         * }
         * where crud-verb is "create" | "update" | "delete"
         * and payload is a json-api structure, which should include a meta
         * component.
         */
        function consume_v5events(json) {
            // first check the type of action we are to perform
            var action = json.command;
            if (COMMANDS.indexOf(action) == -1) {
                return console.warn('Unrecognized command: %s', action);
            }
            // payload should have a data element, which is the core thing
            // that just got created, updated, or deleted
            var data = json.payload && json.payload.data;
            if (!data) {
                return console.warn('No data found for websocket %s', action);
            }
            // data should have required api fields, otherwide there's not much
            // we can do with it.
            if (!data.id) {
                return console.warn('No id found for websocket data of type %s', data.type);
            }
            if (!data.type) {
                return console.warn('No type found for websocket data with id %s', data.id);
            }
            // We should have a meta component, though if we don't that's
            // ok. Just less than ideal.
            var meta = json.payload && json.payload.meta;
            if (!meta) {
                console.warn('No metadata accompanied a \'%s\' event for \'%s\' with id \'%s\'',
                        action, data.type, data.id);
                meta = {};
            }
            meta.action = action;
            var event_data = {
                data: data,
                meta: meta
            };
            apiCh.trigger('remote_raw', event_data);
        }
        ws.on(v5_events, consume_v5events);
        // END Websockets Connection
        globalCh.reply('websocket', function() {
            return ws;
        });

        // set up onstart handler

        // Start the Websockets connection on application start
        apiCh.on('validSession', function() {
            try {
                ws.connect();
            } catch (e) {
                if (e instanceof TypeError) {
                    console.error(e);
                } else {
                    console.warn(e);
                    throw e;
                }
            }
        });

        // Listen for local_editing event and send websocket command
        globalCh.reply('local_editing', function(local_edit) {
            var editing_obj = {
                command: 'editing',
                model_id: local_edit.model_id,
                pane: local_edit.pane
            };
            ws.send(JSON.stringify(editing_obj));
        });
    }

